import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class FsRuleTemplateValidOptions extends SnModel {
  @Expose()
  public objectTypes: FsObjectTypesValidOptions[];

  constructor(data: any = {}) {
    super();

    this.fromJSON(data);
  }
}

export class FsObjectTypesValidOptions extends SnModel {
  @Expose()
  public name: string;

  constructor(data: any = {}) {
    super();

    this.fromJSON(data);
  }
}
